var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.92 19.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "insta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.23,3.56A1.17,1.17,0,1,0,16.4,4.72,1.17,1.17,0,0,0,15.23,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,5.05A4.91,4.91,0,1,0,14.94,10,4.91,4.91,0,0,0,10,5.05Zm0,8.05A3.14,3.14,0,1,1,13.18,10,3.15,3.15,0,0,1,10,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.93,19.92H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0h8a6,6,0,0,1,6,6v8A6,6,0,0,1,13.93,19.92ZM6,1.87A4.12,4.12,0,0,0,1.87,6v8A4.12,4.12,0,0,0,6,18h8A4.11,4.11,0,0,0,18,13.93V6a4.12,4.12,0,0,0-4.11-4.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.8ffa161eb2252e205e0191d5087db9a8.svg";
export { ForwardRef as ReactComponent };